/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import Card from '../../../common/Card'
import Plan from '../Plan/Plan'
import Page from '../../../common/Page'
import Actions from '../../../../actions'
import { MAX_COMPARE_PLANS, MAX_SAVED_PLANS } from 'consts/planConsts'
import { isPlanFavorite } from 'utils/planUtils'
import ActionButton from 'components/common/ActionButton'
import $t from 'i18n'
import { LAYOUT_TYPE } from 'consts'
import { captureScreenshot } from 'utils/planUtils'

import './PlanExtended.css'

const PlanExtended = () => {
  const dispatch = useDispatch()
  const { planId } = useParams()
  const { plans, isPlansLoading, comparePlans, savedPlans } = useSelector(
    state => state.plan
  )
  const isBroker = useSelector(state => state.app.layout === LAYOUT_TYPE.broker)
  const locale = useSelector(state => state.locale?.locale)

  const plan = plans?.find(plan => plan?.antidote_plan_id === planId)

  // check if the plan is already in the compare or saved list and disabled accordingly
  const isCompareDisabled =
    comparePlans?.length >= MAX_COMPARE_PLANS &&
    !comparePlans?.find(comparePlan => comparePlan?.antidote_plan_id === planId)
  const isFavoriteDisabled =
    savedPlans?.length >= MAX_SAVED_PLANS && !isPlanFavorite(plan, savedPlans)

  useEffect(() => {
    if (!plans?.length) {
      dispatch(Actions.createAction(Actions.PLANS_REQUESTED))
    }
  }, [])

  useEffect(() => {
    dispatch(Actions.createAction(Actions.PLANS_REQUESTED))
  }, [locale])


  const openShareQuoteDialog = async () => {
    const dataUrl = await captureScreenshot({ classId: 'plan-details' })

    dispatch(
      Actions.createAction(Actions.SHARE_QUOTE_DIALOG_OPENED, { dataUrl })
    )
  }

  return (
    <Page
      loading={isPlansLoading}
      className='plan-extended-page'
      title={$t('dialogs.comparePlans.title')}
    >
      <div className='plan-extended-container'>
        {isBroker && (
          <ActionButton
            className='plan-share-btn'
            onClick={openShareQuoteDialog}
            icon={'icon-share'}
          >
            {$t('common.share')}
          </ActionButton>
        )}
        <Card className='plan-extended-card' id='plan-details'>
          <Plan
            plan={plan}
            isDetailedView={true}
            isCompareDisabled={isCompareDisabled}
            isFavoriteDisabled={isFavoriteDisabled}
          />
        </Card>
      </div>
    </Page>
  )
}

export default PlanExtended
